import React from 'react';

import { AlertVariant } from './provider';

export interface AlertComponentProps {
  message: string;
  details?: string;
  variant?: AlertVariant;
  onClose: () => void;
}

export function Alert(props: AlertComponentProps) {
  const { message, details, variant = 'info', onClose } = props;
  const color = variant === 'info' ? 'rgba(240, 230, 140, 0.9)' : 'rgba(255, 69, 0, 0.9)';
  return (
    <div
      style={{
        width: '100%',
        height: 'auto',
        maxHeight: '200px',
        backgroundColor: color,
        padding: '1rem',
        marginTop: 10,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'top',
        justifyContent: 'space-between',
      }}
    >
      <div>
        <span>{message}</span>
        {details && <p>{details}</p>}
      </div>
      <div>
        <button style={{ background: 'none', border: 'none' }} onClick={onClose}>
          X
        </button>
      </div>
    </div>
  );
}
